<template>
    <div class="featured-properties">
        <h2 class="label">
            Featured Properties
        </h2>
        <hr v-bind:class="{ tagged: currentProperty.Tag }">
        <div v-if="loading">
            <Spinner size="large" message="Loading..." line-fg-color="#000" style="padding: 5rem 0;"/>
        </div>
        <div v-else-if="nodata">
            Sorry, we can't found your data, please try to access another page.
        </div>
        <div class="featured-property" v-else>
            <div v-if="currentProperty.Tag" class="tag">
                <p>{{currentProperty.Tag | Tag}}</p>
            </div>
            <vueper-slides 
                :autoplay="false"
                fade
                :bullets="window.width > 576 ? false : true"
                :arrows="window.width > 576 ? true : false"
                class="no-shadow"
                :touchable="false"
                :pauseOnHover="false"
                :duration="5000"
                fixed-height="true"
                @slide="currentProperty = data[$event.currentSlide.index]"
                >
                <vueper-slide
                    v-for="(slide, i) in data"
                    :key="i"
                    :image="`${URL}${slide.DisplayImage[0].formats.large.url}`"/>
            </vueper-slides>
            <h3>
                <router-link :to="`/listing/${currentProperty.Slug}`">{{currentProperty.Address}}</router-link>
            </h3>
            <p>
                {{currentProperty.City}} / {{currentProperty.Price | priceFormat}}
            </p>
        </div>
        <router-link to="/properties" class="btn label">
            More Properties
        </router-link>
    </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
import { VueperSlides, VueperSlide } from 'vueperslides';


export default {
    name: "FeaturedProperties",
    components: {
        Spinner,
        VueperSlides,
        VueperSlide
    },
    data(){
        return{
            loading: true,
            data: [],
            nodata: false,
            URL: 'https://api.minnesotapremierrealty.com',
            currentProperty: {},
            window: {
                width: 0,
                height: 0
            }
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
    mounted:function(){
        this.axios.get(`https://api.minnesotapremierrealty.com/property-listings?Featured=true`)
        .then((response) => {
            if(response.data.length === 0){
                this.nodata = true;
            } else {
                this.data = response.data;
                this.currentProperty = this.data[0];
                this.loading = false;
            }
        })
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>

<style lang="scss" scoped>
.featured-properties{
    text-align: center;
    max-width: 1600px;
    margin: 2rem auto;
    padding: 0 15%;
    margin-top: 4rem;
    position: relative;
    h2{
        text-transform: uppercase;
        font-family: 'Mulish', sans-serif;
        font-weight: 800;
        font-size: 13px;
        letter-spacing: 4px;
        margin: 2rem auto;
    }
    hr{
        margin: 2rem auto;
        width: 300px;
        height: 1px;
        background-color: #eee;
        border: none;
        margin-bottom: 2.5rem;
        &.tagged{
            margin-bottom: 4rem;
        }
    }
    .btn{
        display:inline-block;
        margin: 2rem auto;
        color: #000;
    }
    .featured-property{
        position: relative;
        h3{
            text-align: left;
            margin: 0;
            margin-top: 1rem;
            font-size: 25.5px;
            font-weight: 400;
            margin-bottom: 22px;

            a{
                color: #000;
                text-decoration: none;
            }
        }
        p{
            text-align: left;
            margin: 0;
            font-size: 15.5px;
            font-weight: 400;
        }
        .tag{
            top: 0;
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
            margin-top: -24px;
            p{
                font-family: 'Mulish', sans-serif;
                font-weight: 800;
                font-size: 13px;
                letter-spacing: 4px;
            }
        }
    }
}

.vueperslides--fixed-height { height: 800px; }

@media (max-width: 2000px) {
.vueperslides--fixed-height { height: 700px; }
}

@media (max-width: 1800px) {
.vueperslides--fixed-height { height: 600px; }
}

@media (max-width: 1400px) {
.vueperslides--fixed-height { height: 500px; }
}

@media (max-width: $mobile) {
    .vueperslides--fixed-height { height: 300px; }
    .featured-properties{
        margin: 0;
        padding: 0;
        .featured-property{
            margin-top: 3rem;
            h3{
                text-align: center;
                margin: 0;
                margin-top: 2rem;
                font-size: 22.5px;
            }
            p{
                text-align: center;
                margin: 0.5rem 0;
                margin-bottom: 4rem;
            }
        }
    }
}
</style>

<style lang="scss">
.featured-property{
    .vueperslides__bullets{
        bottom: -160px;
        .default {
            width:6px;
            height:6px;
            border-radius: 6px;
            color: #2260ad;
            background-color: #2260ad;
            box-shadow: none;
        }
    }
    .vueperslides__bullet--active{
        .default {
            width:6px;
            height:6px;
            border-radius: 6px;
            color: #5c9eee;
            background-color: #5c9eee;
            border-width: unset;
            box-shadow: none;
        }
    }
}
</style>